export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',

  // cloudbyte追加
  'menu.system.settings': 'System Settings',
  'menu.system.settings.role-management': 'Role Management',
  'menu.system.settings.page-auth-management': 'Page Permission Management',
  'menu.system.settings.account-roles-management': 'Account Role Settings',
  'menu.system.settings.account-management': 'Account Management',
  'menu.system.settings.feedback-management': 'Updates & Feedback',

  'menu.general.affairs': 'General Affairs',
  'menu.general.affairs.attendance-input-onsite': 'Attendance Entry (Onsite)',
  'menu.general.affairs.attendance-input-training': 'Attendance Entry (Training)',
  'menu.general.affairs.attendance-list-onsite': 'Attendance List (Onsite)',
  'menu.general.affairs.attendance-list-training': 'Attendance List (Training)',
  'menu.general.affairs.commute-commit': 'Commute Expense Application',
  'menu.general.affairs.commute-commit-list': 'Commute Expense Application List',
  'menu.general.affairs.oa-requests': 'Leave Requests',
  'menu.general.affairs.oa-approvals': 'Leave Approvals',
  'menu.general.affairs.oa-workflows': 'Leave Approval Flows',
  'menu.general.affairs.fixed-assets': 'Fixed Asset Management',

  // Human Resources Menu
  'menu.human.resources': 'Human Resources',
  'menu.human.resources.employee-personal-update': 'Employee Information Update',
  'menu.human.resources.employee-list': 'Employee Information List',
  'menu.human.resources.employee-list-undefined': 'Undefined Information List',
  'menu.human.resources.employee-info-init': 'Employee Information Update',
  'menu.human.resources.interview-list': 'Interview List',
  'menu.human.resources.document-requests': 'Document Requests',
  'menu.human.resources.document-request-management': 'Document Request Management',

  // Development Department Menu
  'menu.development': 'Development Department',
  'menu.development.learn-analytics': 'Training Data Analysis',
  'menu.development.learn-progress': 'Participant Progress List',
  'menu.development.learn-course': 'Course Management',
  'menu.development.learn-player': 'Attendance, Test',
  'menu.development.stage-exam': 'Stage Exam',
  'menu.development.learn-test': 'Test Page',
  'menu.development.learn-question': 'Question Page',
  'menu.sales': 'Sales',
  'menu.sales.bp-list': 'Business Partner Companies',
  'menu.sales.bp-sales-list': 'BP Sales List',
  'menu.sales.internal-sales-list': 'Internal Sales List',
  'menu.sales.invoice-list': 'Invoice List',
  'menu.accounting': 'Accounting',
  'menu.accounting.dashboard': 'Dashboard',
  'menu.accounting.salary-management': 'Salary Management',
  'menu.internal-notices': 'Internal Notices',
  'menu.system.settings.internal-notices': 'Internal Notice Management',
};
